var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "coupon-modal"
  }, [_c('popup', {
    ref: "popup",
    attrs: {
      "noActions": true,
      "scrolling": true
    }
  }, [_vm.coupon ? _c('coupon', {
    attrs: {
      "coupon": _vm.coupon
    },
    on: {
      "confirmed": _vm.confirmed
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }